import React, { useState } from "react";

export interface ProgressiveImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  wrapperClassName?: string;
  skeletonClassName?: string;
}

export const ProgressiveImage: React.FC<ProgressiveImageProps> = ({
  wrapperClassName = "",
  skeletonClassName = "bg-[#f4e6d8]",
  className = "",
  onLoad,
  onError,
  alt = "",
  ...imgProps
}) => {
  const [loaded, setLoaded] = useState<boolean>(false);

  const handleLoad = (event: React.SyntheticEvent<HTMLImageElement, Event>): void => {
    setLoaded(true);
    if (onLoad) {
      onLoad(event);
    }
  };

  const handleError = (event: React.SyntheticEvent<HTMLImageElement, Event>): void => {
    setLoaded(true);
    if (onError) {
      onError(event);
    }
  };

  return (
    <span className={`relative block overflow-hidden ${wrapperClassName}`} aria-busy={!loaded}>
      <span
        aria-hidden="true"
        className={`absolute inset-0 animate-pulse ${skeletonClassName} transition-opacity duration-500 ${loaded ? "opacity-0" : "opacity-100"}`}
      />
      <img
        {...imgProps}
        alt={alt}
        onLoad={handleLoad}
        onError={handleError}
        className={`relative z-10 transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"} ${className}`.trim()}
      />
    </span>
  );
};

export default ProgressiveImage;
